/* MerchMotten Sizing-Guide-Drawer: oeffnen/schliessen + cm/Zoll-Umschalter */
(function () {
  function toInch(cmText) {
    var raw = String(cmText).trim();
    if (!/^\d+([.,]\d+)?$/.test(raw)) return cmText; /* Bereiche wie "60-66" nicht umrechnen */
    var cm = parseFloat(raw.replace(',', '.'));
    if (isNaN(cm)) return cmText;
    var inch = cm / 2.54;
    var rounded = Math.round(inch * 10) / 10;
    return String(rounded).replace('.', ',');
  }

  function setup(trigger) {
    var id = trigger.getAttribute('data-sg-target');
    var overlay = document.getElementById(id);
    if (!overlay) return;
    /* Portal: raus aus animierten/transformierten Containern, damit
       position:fixed sich immer auf den Viewport bezieht */
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    /* Portal: raus aus transformierten Containern (Scroll-Animationen),
       sonst bezieht sich position:fixed auf die Spalte statt auf den Viewport */
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    var panel = overlay.querySelector('.sg-panel');
    var closeBtn = overlay.querySelector('.sg-close');

    function open() {
      overlay.classList.add('sg-open');
      document.body.classList.add('sg-locked');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      overlay.classList.remove('sg-open');
      document.body.classList.remove('sg-locked');
      trigger.focus();
    }

    trigger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('sg-open')) close();
    });

    overlay.querySelectorAll('.sg-units button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-unit');
        overlay.querySelectorAll('.sg-units button').forEach(function (b) {
          b.classList.toggle('sg-active', b === btn);
        });
        overlay.querySelectorAll('[data-cm]').forEach(function (cell) {
          var cmVal = cell.getAttribute('data-cm');
          cell.textContent = unit === 'in' ? toInch(cmVal) : cmVal;
        });
        overlay.querySelectorAll('[data-unit-label]').forEach(function (el) {
          el.textContent = unit === 'in'
            ? (el.getAttribute('data-label-in') || '(in)')
            : (el.getAttribute('data-label-cm') || '(cm)');
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-sg-target]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
